import React, { useContext } from 'react';

import {
  getApprovalKeyword,
  getConfirmationTitle,
} from '@atom/components/common/requests/customTenantUtilities';
import { Modal } from '@atom/mui';
import { AssetRequestStatus } from '@atom/types/assetRequest';

import ViewRequestContext from './ViewRequestContext';

import './viewRequest.css';

interface Props {
  updateRequest: () => void;
}

const ConfirmationModal = ({ updateRequest }: Props) => {
  const { status, confirmOpen, setConfirmOpen } =
    useContext(ViewRequestContext);

  const isApproval =
    status === AssetRequestStatus.FULL_APPROVAL ||
    status === AssetRequestStatus.PARTIAL_APPROVAL ||
    status === AssetRequestStatus.PENDING_APPROVAL ||
    status === AssetRequestStatus.APPROVED;

  const approvalKeyword = getApprovalKeyword(status);
  const cancelText =
    status === AssetRequestStatus.CANCELED ? 'Do Not Cancel' : 'Cancel';
  const confirmText =
    status === AssetRequestStatus.CANCELED ? 'Cancel Request' : approvalKeyword;
  const buttonColor = isApproval ? 'primary' : 'error';
  const title = getConfirmationTitle(approvalKeyword);

  return (
    <Modal
      open={confirmOpen}
      onCancel={() => setConfirmOpen(false)}
      cancelButtonText={cancelText}
      onConfirm={updateRequest}
      confirmButtonText={confirmText}
      title={title}
      ConfirmButtonProps={{ color: buttonColor }}
    >
      {`Are you sure you want to ${approvalKeyword} this transfer request?`}
    </Modal>
  );
};

export default ConfirmationModal;
